import{useStoreContext as o}from"../../../providers/StoreProvider/index.js";function t(){return o().locale}export{t as default};
//# sourceMappingURL=index.js.map
